export const storeAnsweredQuestion = (state, answerObject) => {
  const { questionId, answerIndex } = answerObject;
  state.userAnswers[questionId] = answerIndex;
  console.log(answerObject);
};
export const stepButtonClicked = (state, stepId) => {
  const { userProductResults } = state;
  //rolling back changes
  Object.keys(userProductResults).forEach(productResult => {
    state.userProductResults[productResult].splice(
      stepId,
      userProductResults[productResult].length
    );
  });
  state.currentStep = stepId;
  state.showSlidePostEnding = false;
  state.showSlidePreBegin = false;
};
export const setQuestionsArray = (state, questionsArray) => {
  if (questionsArray) {
    state.questionsArray = questionsArray;
  }
};

export const setMatrixArray = (state, matrixArray) => {
  state.matrixArray = matrixArray;
};
export const setCurrentStep = (state, currentStep) => {
  state.currentStep = currentStep;
};
export const setProductAnswersArray = (state, productAnswersArray) => {
  state.productAnswersArray = productAnswersArray;
};

export const setUserProductResults = (state, { productId, weight }) => {
  if (state.userProductResults[productId]) {
    state.userProductResults[productId].push(weight);
  } else {
    state.userProductResults[productId] = [weight];
  }
};
export const setlikeliestProductsList = (state, likeliestProductsList) => {
  state.likeliestProductsList = likeliestProductsList;
};
export const setShowSlidePostEnding = (state, showSlidePostEnding) => {
  state.showSlidePostEnding = showSlidePostEnding;
};
export const setShowSlidePreBegin = (state, showSlidePreBegin) => {
  state.showSlidePreBegin = showSlidePreBegin;
};
export const setQuizRestUrls = (state, quizRestUrls) => {
  state.quizRestUrls = quizRestUrls;
};
export const setProducts = (state, products) => {
  state.products = products;
};
export const setEndingStep = (state, endingStep) => {
  state.currentEndingStep = endingStep;
};
export const setSiteSettings = (state, siteSettings) => {
  // just making sure we not overidding default with falsy value,validation up to site admin
  if (siteSettings) {
    // Object.keys(siteSettings).forEach(key => {
    //   if (siteSettings[key]) {
    //     state.siteSettings[key] = siteSettings[key];
    //   }
    // });
    state.siteSettings = siteSettings;
  }
  //console.log(siteSettings);
};

export const setShowLoader = (state, showLoader) => {
  state.showLoader = showLoader;
};
export const setQuiz = (state, quiz) => {
  //console.log(quiz);
  state.quiz = quiz;
};
export const setAdmin = (state, admin) => {
  state.admin = admin;
};
export const setUser = (state, user) => {
  state.user = user;
};
export const setDebugInfo = (state, debugInformation) => {
  state.debugInformation = debugInformation;
};
export const setDisableUser = (state, disableUser) => {
  state.disableUser = disableUser;
};

export const updateOneProduct = (state, productData) => {
  const { products } = state;
  if (products.length) {
    const id = products.findIndex(product => {
      return product.id == productData.id;
    });
    state.products[id] = { ...products[id], ...productData };
  }
};
export const setNonce = (state, nonce) => {
  const { quizRestUrls } = state;
  if (quizRestUrls) {
    Object.keys(quizRestUrls).forEach(key => {
      state.quizRestUrls[key].nonce = nonce;
    });
  }
};
export const reduceRetries = state => {
  if (state.retries) {
    state.retries = state.retries - 1;
    state.addToCartFallBack = false;
    if (!state.retries) {
      state.addToCartFallBack = true;
    }
  }
};
export const resetRetries = state => {
  state.retries = 5;
};

export const setShareLinks = (state, shareLinks) => {
  state.shareLinks = shareLinks;
};
export const setIsOwnerOfResults = (state, isOwnerOfResults) => {
  state.isOwnerOfResults = isOwnerOfResults;
  state.resultsSharedPageView = true;
};

export const resetAll = state => {
  state.showLoader = true;
  setTimeout(() => {
    state.showSlidePostEnding = false;
    state.currentEndingStep = null;
    state.isOwnerOfResults = true;
    state.showLoader = false;
  }, 1000);
};
